"use client";

import {Input} from "@heroui/input";
import {Link} from "@heroui/link";

import React from "react";
import {getRss} from "./action";
import posthog from "posthog-js";
import {Button} from "@heroui/button";
import {getQueryParam, showConfetti} from "@/components/DownloaderApp/utils";

export const isProd = process.env.NEXT_PUBLIC_NODE_ENV === "production";

function isValidHttpUrl(str) {
    try {
        const url = new URL(str);
        return url.protocol === "https:";
    } catch {
        return false;
    }
}


// https://www.newskeeper.io/tools/youtube-rss?query=https%3A%2F%2Fwww.youtube.com%2F%40bigclivedotcom

export default function YoutubeToRssFrontend() {

    let queryParamUrl

    try {
        queryParamUrl = getQueryParam(window.location.href, "url");
    }catch(err) {

    }

    const [text, setText] = React.useState(queryParamUrl ? queryParamUrl : isProd ? '' : "https://www.youtube.com/channel/UC_x5XG1OV2P6uZZ5FSM9Ttw");

    const [result, setResult] = React.useState(isProd ? [] : [
        ['https://www.youtube.com/feeds/videos.xml?playlist_id=UULF_x5XG1OV2P6uZZ5FSM9Ttw', 'All Content'],
        ['https://www.youtube.com/feeds/videos.xml?playlist_id=UULF_x5XG1OV2P6uZZ5FSM9Ttw2', 'All Content2']
    ]);
    const [error, setError] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        if(queryParamUrl) {
            onchange({ target: { value: queryParamUrl}})
        }
    }, [queryParamUrl])

    async function onchange(e: React.ChangeEvent<HTMLInputElement>) {
        setResult([])
        setError('')
        setIsLoading(true);
        console.log(e.target.value);

        const urlText = (e.target.value || '').trim();

        try {
            posthog.capture(`Youtube Channel RSS Requested`, {
                ytChannelUrl: urlText
            })
        } catch (e) {

        }

        if (!isValidHttpUrl(urlText)) {
            console.error("URL is invalid");
            setError('URL is invalid');
            setIsLoading(false);
            return;
        }
        const url = new URL(urlText);

        const validDomain = url.host === 'www.youtube.com' || url.host === 'youtube.com' || url.host === 'youtu.be';
        if (!validDomain) {
            setError('URL is invalid');
            setIsLoading(false);
            return;
        }

        try {
            const {channelId, playlistId} = await getRss(urlText);
            const rss = 'https://www.youtube.com/feeds/videos.xml?playlist_id=' + channelId.replace('UC', 'UULF');
            if (!channelId) {
                throw new Error("not found");
            }

            let rssFeeds = [
                ['UC', 'All Content', 'channel_id'],
                ['UULF', 'Videos', 'playlist_id'],
                ['UUSH', 'Shorts', 'playlist_id'],
                ['UULV', 'Live Streams', 'playlist_id'],
            ].map(([prefix, label, queryParam]) => {
                return [`https://www.youtube.com/feeds/videos.xml?${queryParam}=` + channelId.replace('UC', prefix), label]
            });

            if(playlistId) {
                rssFeeds = [
                    [`https://www.youtube.com/feeds/videos.xml?playlist_id=` + playlistId, 'Playlist Videos'],
                    ...rssFeeds
                ]
            }

            console.log({rssFeeds})
            setResult(rssFeeds);
            showConfetti()
        } catch (err) {
            try {
                posthog.capture(`Youtube Channel RSS Error`, {
                    errMessage: err.message,
                    ytChannelUrl: urlText
                })
            } catch (e) {

            }
            setError('Sorry, not found!');
        }
        setIsLoading(false)

    }

    return <div>
        <Input autoFocus labelPlacement={"outside"} label={"Youtube channel URL:"} variant="bordered" size={"lg"}
               value={text} onValueChange={setText} onChange={onchange}
               type="text" placeholder={'https://www.youtube.com/@HTXStudio'}/>
        {
            isLoading ? <div className={"mt-4"}>Loading...</div> : null
        }
        {
            error ? <div className={"mt-4"}>{error}</div> : null
        }
        {
            result.length ? (<div className={"mt-4 flex flex-col gap-2"}>
                <div className={"flex gap-4"}>
                    <div className={"flex flex-col gap-2"}>
                        {result.map(([, label]) => (<h2 className={"flex flex-col flex-grow justify-center"} key={label}>{label}:</h2>))}
                    </div>
                    <div className={"flex flex-col gap-2"}>
                        {result.map(([url, label]) => (
                            <div className={"flex flex-col flex-grow justify-center"} key={label}>
                                <Link key={label} target={'_blank'} href={url}>{url}</Link>
                            </div>
                        ))}
                    </div>
                    <div className={"flex flex-col gap-2"}>
                        {result.map(([url, label]) => (
                            <div className={"flex flex-col flex-grow justify-center"} key={label}>
                                {/*<Button as={Link} size={'sm'} color={'primary'} target={'_blank'} href={`https://feedly.com/i/discover?query=suggesto%2F${encodeURIComponent(url)}`}>+ Add to Feedly</Button>*/}
                                <Button as={Link} size={'sm'} color={'primary'} target={'_blank'} href={`https://feedly.com/i/discover?s=feedPreview:${encodeBase64(JSON.stringify({"scheme":"","feedId":"feed/"+url}))}`}>+ Add to Feedly</Button>
                            </div>
                        ))}
                    </div>
                </div>


            </div>) : null

        }
    </div>;
};

function encodeBase64(str) {
    return Buffer.from(str, "utf-8").toString("base64");
}

//https://feedly.com/i/discover?query=suggesto%2F